// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3KkST","head":"Table_head__2ZaXB","col":"Table_col__3OcW2"};